import { render } from "./MyCreationsView.vue?vue&type=template&id=8e88e726&scoped=true"
import script from "./MyCreationsView.vue?vue&type=script&lang=js"
export * from "./MyCreationsView.vue?vue&type=script&lang=js"

import "./MyCreationsView.vue?vue&type=style&index=0&id=8e88e726&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e88e726"]])

export default __exports__